import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Heading, Inline, Stack, Text } from '@ui-lib';
import { useState } from 'react';
import type { TooltipRenderProps } from 'react-joyride';
import { tokens } from 'ui-lib/src/lib/css/tokens';

import { closeButtonContainer, placeholderContainer, tooltipContainer } from './ValueProvider.css';

export function TooltipComponent({
  index,
  isLastStep,
  primaryProps,
  step,
  tooltipProps,
  size,
}: TooltipRenderProps) {
  const [isLoading, setIsLoading] = useState(false);

  async function handleOnclick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    const submitAction = step.data?.submitAction;
    if (submitAction) {
      setIsLoading(true);
      await submitAction();
      setIsLoading(false);
    }
    primaryProps.onClick(event);
  }

  return (
    <Box
      background="body"
      {...tooltipProps}
      display="flex"
      flexDirection="column"
      borderRadius="xlarge"
      className={tooltipContainer}
    >
      <Box className={placeholderContainer} display="flex" justifyContent="center">
        <Button onClick={handleOnclick} disabled={isLoading} variant="text" className={closeButtonContainer}>
          <FontAwesomeIcon style={{ color: tokens.color.background.body }} icon={faTimes} />
        </Button>
        <Box width="full" component="img" src={step.data?.image} alt="Card placeholder" />
      </Box>
      <Box display="flex" flexDirection="column" padding="large" gap="large">
        <Stack gap="medium">
          <Heading level="6" weight="demibold">
            {step.title}
          </Heading>
          <Text size="small" tone="secondary">
            {step.content}
          </Text>
        </Stack>
        <Inline gap="medium" alignY="center">
          <Button loading={isLoading} type="button" onClick={handleOnclick}>
            {isLastStep ? 'Got it!' : 'Next'}
          </Button>
          <Text>
            {index + 1} of {size}
          </Text>
        </Inline>
      </Box>
    </Box>
  );
}
